/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Round_Not_CancelledInputs */



/**
* | output |
* | --- |
* | "Round is not cancelled" |
*
* @param {Err_Tournament_Round_Not_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_round_not_cancelled = /** @type {((inputs?: Err_Tournament_Round_Not_CancelledInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Round_Not_CancelledInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La ronde n'est pas annulée")
	if (locale === "es") return /** @type {LocalizedString} */ ("La ronda no está cancelada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A rodada não está cancelada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il round non è annullato")
	return /** @type {LocalizedString} */ ("Round is not cancelled")
});